import createIcon from '../../createIcon';

/**
 * @component @name HeadphonesBattery
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgN0gyMFY2SDE4VjdIMTdDMTYuNDUgNyAxNiA3LjQ1IDE2IDhWMTdDMTYgMTcuNTUgMTYuNDUgMTggMTcgMThIMjFDMjEuNTUgMTggMjIgMTcuNTUgMjIgMTdWOEMyMiA3LjQ1IDIxLjU1IDcgMjEgN1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik04IDZDNC42OSA2IDIgOC42OSAyIDEyVjE2QzIgMTcuMSAyLjkgMTggNCAxOEg2VjEzSDMuNVYxMkMzLjUgOS41MiA1LjUyIDcuNSA4IDcuNUMxMC40OCA3LjUgMTIuNSA5LjUyIDEyLjUgMTJWMTNIMTBWMThIMTJDMTMuMSAxOCAxNCAxNy4xIDE0IDE2VjEyQzE0IDguNjkgMTEuMzEgNiA4IDZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HeadphonesBattery = createIcon('HeadphonesBattery', [
  [
    'path',
    {
      d: 'M21 7H20V6H18V7H17C16.45 7 16 7.45 16 8V17C16 17.55 16.45 18 17 18H21C21.55 18 22 17.55 22 17V8C22 7.45 21.55 7 21 7Z',
      key: '2yh1ck',
    },
  ],
  [
    'path',
    {
      d: 'M8 6C4.69 6 2 8.69 2 12V16C2 17.1 2.9 18 4 18H6V13H3.5V12C3.5 9.52 5.52 7.5 8 7.5C10.48 7.5 12.5 9.52 12.5 12V13H10V18H12C13.1 18 14 17.1 14 16V12C14 8.69 11.31 6 8 6Z',
      key: '12mxm2',
    },
  ],
]);

export default HeadphonesBattery;
